import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { Toast } from 'mint-ui'
import { Dialog } from 'vant'
import { getOpenid } from '@/api/login'
import { isLogin } from '@/assets/js/common'

import { weiXinShare } from '@/utils/wxShare'

import { getSearchString } from '@/utils'

Vue.use(Router)
let Timer = null

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'login',
    //   redirect: 'login'
    // },
    {
      path: '/',
      name: 'currentIndex',
      redirect: 'currentIndex'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login.vue'),
      meta: {
        title: '智娃陪读机器人-绑定激活'
      }
    },
    {
      path: '/getFreeSkills',
      name: 'getFreeSkills',
      component: () => import('@/views/login/get-free-skills.vue'),
      meta: {
        title: '免费领取技能',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/agreePrivacy',
      name: 'agreePrivacy',
      component: () => import('@/views/common/agreePrivacy.vue'),
      meta: {
        title: '隐私政策',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/agreeUser',
      name: 'agreeUser',
      component: () => import('@/views/common/agreeUser.vue'),
      meta: {
        title: '用户许可使用协议',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/pad/agreePrivacy',
      name: 'agreePrivacyForPad',
      component: () => import('@/views/common/pad/agreePrivacy.vue'),
      meta: {
        title: '隐私政策',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/pad/agreeUser',
      name: 'agreeUserForPad',
      component: () => import('@/views/common/pad/agreeUser.vue'),
      meta: {
        title: '用户许可使用协议',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/pad/LegalandDisclaimer',
      name: 'legalDisclaimerForPad',
      component: () => import('@/views/common/pad/legalDisclaimer.vue'),
      meta: {
        title: '法律及免责声明',
        requireAuth: true,
        index: 1
      }
    },
    // {
    //   path: '/share',
    //   name: 'share',
    //   component: () => import('@/views/share/share.vue'),
    //   meta: {
    //     title: '智娃陪读机器人',
    //     requireAuth: true,
    //     index: 1
    //   }
    // },
    {
      path: '/bindtips',
      name: 'bindtips',
      component: () => import('@/views/faq/bindtips.vue'),
      meta: {
        title: '绑定领礼包',
        requireAuth: true,
        index: 1
      }
    },
    {
      path: '/home',
      name: 'home',
      // redirect: 'currentIndex',
      component: () => import('@/views/Home.vue'),
      children: [
        {
          path: '/index',
          name: 'index',
          component: () => import('@/views/index/index'),
          meta: {
            title: '宝贝动态',
            requireAuth: true,
            index: 1
          }
        },
        {
          path: '/currentIndex',
          name: 'currentIndex',
          component: () => import('@/views/index/current-index'),
          meta: {
            title: '学习',
            requireAuth: true,
            index: 1
          }
        },
        {
          path: '/shopping/:resource?',
          name: 'shopping',
          component: () => import('@/views/shopping/shopping'),
          meta: {
            title: '商城',
            requireAuth: true,
            index: 2
          },
          beforeEnter (to, from, next) {
            // 小天才服务号限制
            if (store.state.isXTC == 1) { // eslint-disable-line
              Dialog.alert({
                message: '此功能仅限在微信中‘智娃陪读机器人’公众号中使用'
              }).then(() => {
                next('/currentIndex')
              })
            } else {
              next()
            }
          }
        },
        {
          path: '/management',
          name: 'management',
          component: () => import('@/views/management/management'),
          meta: {
            title: '宝贝管理',
            requireAuth: true,
            index: 3
          }
        },
        {
          path: '/skill',
          name: 'skill',
          component: () => import('@/views/skill/skill'),
          meta: {
            title: '技能',
            requireAuth: true,
            index: 4
          }
        },
        {
          path: '/learningAssistant',
          name: 'learningAssistant',
          component: () => import('@/views/assistant/learning-assistant.vue'),
          meta: {
            title: '学习助手',
            requireAuth: true,
            index: 5
          },
          beforeEnter (to, from, next) {
            let jurisdictionId = sessionStorage.getItem('jurisdictionId')
            if (store.state.kidLists.length === 0 && from.name && from.name !== 'login' && from.name !== 'learningAssistantReport' && from.name !== 'learningAssistantDetail') {
              Toast({
                message: '请先完成设备绑定',
                duration: 1500
              })
              Timer = setTimeout(() => {
                next('/management')
              }, 1600)
            } else if (jurisdictionId === 2) {
              next('/learningAssistantNew')
            } else {
              next()
            }
          }
        },
        {
          path: '/learningAssistantNewCore',
          name: 'learningAssistantNewCore',
          component: () => import('@/views/assistant/components/examine-status.vue'),
          meta: {
            title: '核心技能',
            requireAuth: true,
            index: 2
          },
          beforeEnter (to, from, next) {
            if (store.state.kidLists.length === 0 && from.name && from.name !== 'login' && from.name !== 'learningAssistantReport' && from.name !== 'learningAssistantDetail') {
              Toast({
                message: '请先完成设备绑定',
                duration: 1500
              })
              Timer = setTimeout(() => {
                next('/management')
              }, 1600)
            } else {
              next()
            }
          }
        },
        {
          path: '/learningAssistantNew',
          name: 'learningAssistantNew',
          component: () => import('@/views/assistant/learning-assistant-new.vue'),
          meta: {
            title: '其他技能',
            requireAuth: true,
            index: 2
          },
          beforeEnter (to, from, next) {
            if (store.state.kidLists.length === 0 && from.name && from.name !== 'login' && from.name !== 'learningAssistantReport' && from.name !== 'learningAssistantDetail') {
              Toast({
                message: '请先完成设备绑定',
                duration: 1500
              })
              Timer = setTimeout(() => {
                next('/management')
              }, 1600)
            } else {
              next()
            }
          }
        }
      ]
    },
    {
      path: '/shopIntroduction',
      name: 'shopIntroduction',
      component: () => import('@/views/shopping/introduction.vue'),
      meta: {
        title: '智娃陪读产品介绍',
        requireAuth: true
      }
    },
    {
      path: '/managementDetail',
      name: 'managementDetail',
      component: () => import('@/views/management/management-detail.vue'),
      meta: {
        title: '宝贝信息',
        requireAuth: true
      }
    },
    {
      path: '/managementDevices',
      name: 'managementDevices',
      component: () => import('@/views/management/management-devices.vue'),
      meta: {
        title: '设备管理',
        requireAuth: true
      }
    },
    {
      path: '/managementBind',
      name: 'managementBind',
      component: () => import('@/views/management/management-bind.vue'),
      meta: {
        title: '设备绑定',
        requireAuth: true
      }
    },
    {
      path: '/skillOverview',
      name: 'skillOverview',
      component: () => import('@/views/skill/skill-overview.vue'),
      meta: {
        title: '技能概览',
        requireAuth: true
      }
    },
    {
      path: '/skillDetail',
      name: 'skillDetail',
      component: () => import('@/views/skill/skill-detail.vue'),
      meta: {
        title: '技能详情',
        requireAuth: true
      }
    },
    {
      path: '/skillDetailNew',
      name: 'skillDetailNew',
      component: () => import('@/views/skill/skill-detail-new.vue'),
      meta: {
        title: '技能详情',
        requireAuth: true
      }
    },
    {
      path: '/skillGrade',
      name: 'skillGrade',
      component: () => import('@/views/skill/skill-grade.vue'),
      meta: {
        title: '年级分类',
        requireAuth: true
      }
    },
    {
      path: '/skillDetailToday',
      name: 'skillDetailToday',
      component: () => import('@/views/skill/skill-detail-today.vue'),
      meta: {
        title: '今日详情',
        requireAuth: true
      }
    },
    {
      path: '/todayLearn/:date',
      name: 'todayLearn',
      component: () => import('@/views/index/todaylearn.vue'),
      meta: {
        title: '今日学习情况',
        requireAuth: true
      }
    },
    {
      path: '/learningAssistantDetail',
      name: 'learningAssistantDetail',
      component: () => import('@/views/assistant/learning-assistant-detail.vue'),
      meta: {
        title: '学习助手详情',
        requireAuth: true
      }
    },
    {
      path: '/learningAssistantReport',
      name: 'learningAssistantReport',
      component: () => import('@/views/assistant/learning-assistant-report.vue'),
      meta: {
        title: '学习报告',
        requireAuth: true
      }
    },
    {
      path: '/learningResult',
      name: 'learningResult',
      component: () => import('@/views/assistant/learning-result.vue'),
      meta: {
        title: '考评结果',
        requireAuth: true
      }
    },
    {
      path: '/skillNewDescription/:skillId',
      name: 'skillNewDescription',
      component: () => import('@/views/skill/skill-new-description.vue'),
      meta: {
        title: '技能介绍',
        requireAuth: true
      }
    },
    {
      path: '/skillDescription/:resource?/:skillId?',
      name: 'skillDescription',
      component: () => import('@/views/skill/skill-description.vue'),
      meta: {
        title: '技能介绍',
        requireAuth: true
      }
    },
    {
      path: '/skillDescriptionVisitor/:skillId/:memberId/:currrntShow?',
      name: 'skillDescriptionVisitor',
      component: () => import('@/views/skill/skill-description-visitor.vue'),
      meta: {
        title: '技能详情',
        requireAuth: true
      }
    },
    {
      path: '/skillListsVisitor/:memberId',
      name: 'skillListsVisitor',
      component: () => import('@/views/shopping/skill-lists-visitor.vue'),
      meta: {
        title: '技能列表',
        requireAuth: true
      }
    },
    {
      path: '/shoppingVisitor/:memberId/:report?',
      name: 'shoppingVisitor',
      component: () => import('@/views/shopping/shopping-visitor.vue'),
      meta: {
        title: '商城',
        requireAuth: true
      }
    },
    {
      path: '/vip/:resource?',
      name: 'vip',
      component: () => import('@/views/shopping/vip.vue'),
      meta: {
        title: '商城',
        requireAuth: true
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/views/faq/faq-index.vue'),
      meta: {
        title: '常见问题',
        requireAuth: true
      }
    },
    {
      path: '/faqDetail',
      name: 'faqDetail',
      component: () => import('@/views/faq/faq-detail.vue'),
      meta: {
        title: '常见问题',
        requireAuth: true
      }
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: () => import('@/views/active/introduce.vue'),
      meta: {
        title: '最近孩子爱学习了，原来是在用智娃陪读',
        requireAuth: true
      }
    },
    {
      path: '/image',
      name: 'image',
      component: () => import('@/views/active/image.vue'),
      meta: {
        title: '智娃形象',
        requireAuth: true
      }
    },
    {
      path: '/rotatePage',
      name: 'rotatePage',
      component: () => import('@/views/common/rotatePage.vue'),
      meta: {
        title: '禁止横屏',
        requireAuth: true
      }
    },
    // 以下都是运维活动页面
    {
      path: '/winderActive',
      name: 'winderActive',
      component: () => import('@/views/active/winter.vue'),
      meta: {
        title: '知识大挑战',
        requireAuth: true
      }
    },
    {
      path: '/childrenActive',
      name: 'childrenActive',
      component: () => import('@/views/active/childrenActive.vue'),
      meta: {
        title: '集卡分现金',
        requireAuth: true
      }
    },
    {
      path: '/teacherActive',
      name: 'teacherActive',
      component: () => import('@/views/active/teacherActive.vue'),
      meta: {
        title: '开学大作战',
        requireAuth: true
      }
    },
    {
      path: '/studyRankingActive',
      name: 'studyRankingActive',
      component: () => import('@/views/active/study-ranking-active.vue'),
      meta: {
        title: '超级小学霸',
        requireAuth: true
      }
    },
    {
      path: '/formPage',
      name: 'formPage',
      component: () => import('@/views/active/form-page.vue'),
      meta: {
        title: '填写信息',
        requireAuth: true
      }
    },
    {
      path: '/summerFormPage',
      name: 'summerFormPage',
      component: () => import('@/views/active/summer-form-page.vue'),
      meta: {
        title: '填写信息',
        requireAuth: true
      }
    },
    {
      path: '/summerActive',
      name: 'summerActive',
      component: () => import('@/views/active/summer-active.vue'),
      meta: {
        title: '暑假活动',
        requireAuth: true
      }
    },
    {
      path: '/summerActiveTwo',
      name: 'summerActiveTwo',
      component: () => import('@/views/active/summer-active-two.vue'),
      meta: {
        title: '暑假活动',
        requireAuth: true
      }
    },
    {
      path: '/summerActiveThree',
      name: 'summerActiveThree',
      component: () => import('@/views/active/summer-active-three.vue'),
      meta: {
        title: '六一儿童节活动',
        requireAuth: true
      }
    },
    {
      path: '/summerActiveThreeProduct',
      name: 'summerActiveThreeProduct',
      component: () => import('@/views/active/summerActiveThreeProduct.vue'),
      meta: {
        title: '智娃文具大礼包',
        requireAuth: true
      }
    },
    {
      path: '/teacherActivePromotion',
      name: 'teacherActivePromotion',
      component: () => import('@/views/active/teacher-active-promotion.vue'),
      meta: {
        title: '活动促销',
        requireAuth: true
      }
    },
    {
      path: '/vipUserActive',
      name: 'vipUserActive',
      component: () => import('@/views/active/vipActive.vue'),
      meta: {
        title: '智娃陪读',
        requireAuth: true
      }
    },
    {
      path: '/lampActive',
      name: 'lampActive',
      component: () => import('@/views/active/components/doubleEleven/lampActive.vue'),
      meta: {
        title: '2.5折限量抢购',
        requireAuth: true
      }
    },
    {
      path: '/buyGoods',
      name: 'buyGoods',
      component: () => import('@/views/active/components/doubleEleven/buy_goods.vue'),
      meta: {
        title: '填写收货信息',
        requireAuth: true
      }
    },
    {
      path: '/popup/:sort/:type?',
      name: 'popup',
      component: () => import('@/views/active/components/doubleEleven/popup.vue'),
      meta: {
        title: '双11活动预告',
        requireAuth: true
      }
    },
    {
      path: '/address',
      name: 'address',
      component: () => import('@/views/active/components/nationalDay/address.vue'),
      meta: {
        title: '填写地址',
        requireAuth: true
      }
    },
    {
      path: '/addressAndSearch',
      name: 'addressAndSearch',
      component: () => import('@/views/common/addressAndSearch.vue'),
      meta: {
        title: '填写信息',
        requireAuth: true
      }
    },
    {
      path: '/teacherActivePromotion',
      name: 'teacherActivePromotion',
      component: () => import('@/views/active/teacher-active-promotion.vue'),
      meta: {
        title: '活动促销',
        requireAuth: true
      }
    },
    {
      path: '/oldUserActive',
      name: 'oldUserActive',
      component: () => import('@/views/active/oldUserActive.vue'),
      meta: {
        title: '感恩老用户',
        requireAuth: true
      }
    },
    {
      path: '/alreadySkillActive',
      name: 'alreadySkillActive',
      component: () => import('@/views/active/already-skill-active.vue'),
      meta: {
        title: '感恩老用户',
        requireAuth: true
      }
    },
    {
      path: '/midAutumn',
      name: 'midAutumn',
      component: () => import('@/views/active/mid-autumn.vue'),
      meta: {
        title: '中秋特辑',
        requireAuth: true
      }
    },
    {
      path: '/nationalDay',
      name: 'nationalDay',
      component: () => import('@/views/active/nationalDay.vue'),
      meta: {
        title: '国庆特辑',
        requireAuth: true
      }
    },
    {
      path: '/lampActive',
      name: 'lampActive',
      component: () => import('@/views/active/components/doubleEleven/lampActive.vue'),
      meta: {
        title: '2.5折限量抢购',
        requireAuth: true
      }
    },
    {
      path: '/buyGoods',
      name: 'buyGoods',
      component: () => import('@/views/active/components/doubleEleven/buy_goods.vue'),
      meta: {
        title: '填写收货信息',
        requireAuth: true
      }
    },
    {
      path: '/address',
      name: 'address',
      component: () => import('@/views/active/components/nationalDay/address.vue'),
      meta: {
        title: '填写地址',
        requireAuth: true
      }
    },
    {
      path: '/addressAndSearch',
      name: 'addressAndSearch',
      component: () => import('@/views/common/addressAndSearch.vue'),
      meta: {
        title: '填写信息',
        requireAuth: true
      }
    },
    {
      path: '/summerProduct',
      name: 'summerProduct',
      component: () => import('@/views/active/summer-product.vue'),
      meta: {
        title: '产品介绍',
        requireAuth: true
      }
    },
    {
      path: '/makeAppointment',
      name: 'makeAppointment',
      component: () => import('@/views/active/components/makeAppointment.vue'),
      meta: {
        title: '预约结果',
        requireAuth: true
      }
    },
    // {
    //   path: '/summaryPage',
    //   name: 'summaryPage',
    //   component: () => import('@/views/active/components/summaryPage/summaryPage.vue'),
    //   meta: {
    //     title: '2019年度总结',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/summaryPageResult',
      name: 'summaryPageResult',
      component: () => import('@/views/active/components/summaryPage/result.vue'),
      meta: {
        title: '提示',
        requireAuth: true
      }
    },
    {
      path: '/loborDay',
      name: 'loborDay',
      component: () => import('@/views/active/components/loborDay/loborDay.vue'),
      meta: {
        title: '智娃陪读',
        requireAuth: true
      }
    },
    {
      path: '/scientificReport/:kidId/:timestamp/:memberId?',
      name: 'scientificReport',
      component: () => import('@/views/active/components/scientificReport/scientificReport.vue'),
      meta: {
        title: '我的科学学习报告',
        requireAuth: true
      }
    },
    {
      path: '/scientificSkillReport/:kidId/:timestamp?',
      name: 'scientificSkillReport',
      component: () => import('@/views/active/components/scientificReport/scientificSkillReport.vue'),
      meta: {
        title: '我的科学学习报告',
        requireAuth: true
      }
    },
    {
      path: '/loading/:timestamp/:memberId?',
      name: 'loading',
      component: () => import('@/views/active/components/scientificReport/loading.vue'),
      meta: {
        title: '学习报告',
        requireAuth: true
      }
    },
    {
      path: '/chineseReport/:kidId/:timestamp/:memberId?',
      name: 'chineseReport',
      component: () => import('@/views/active/components/scientificReport/chineseReport.vue'),
      meta: {
        title: '我的语文学习报告',
        requireAuth: true
      }
    },
    {
      path: '/mathReport/:kidId/:timestamp/:memberId?',
      name: 'mathReport',
      component: () => import('@/views/active/components/scientificReport/mathReport.vue'),
      meta: {
        title: '我的数学学习报告',
        requireAuth: true
      }
    },
    {
      path: '/englishReport/:kidId/:timestamp/:memberId?',
      name: 'englishReport',
      component: () => import('@/views/active/components/scientificReport/englishReport.vue'),
      meta: {
        title: '我的英语学习报告',
        requireAuth: true
      }
    },
    {
      path: '/alreadySkillActive',
      name: 'alreadySkillActive',
      component: () => import('@/views/active/already-skill-active.vue'),
      meta: {
        title: '感恩老用户',
        requireAuth: true
      }
    },
    {
      path: '/midAutumn',
      name: 'midAutumn',
      component: () => import('@/views/active/mid-autumn.vue'),
      meta: {
        title: '中秋特辑',
        requireAuth: true
      }
    },
    {
      path: '/nationalDay',
      name: 'nationalDay',
      component: () => import('@/views/active/nationalDay.vue'),
      meta: {
        title: '国庆特辑',
        requireAuth: true
      }
    },
    {
      path: '/pictureDown/:id',
      name: 'pictureDown',
      component: () => import('@/views/active/components/oneYears/pictureDown.vue'),
      meta: {
        title: '图片下载',
        requireAuth: true
      }
    },
    {
      path: '/oneYearAnniversary/:kidId/:timestamp',
      name: 'oneYearAnniversary',
      component: () => import('@/views/active/components/oneYears/oneYearAnniversary.vue'),
      meta: {
        title: '一周年',
        requireAuth: true
      }
    },
    {
      path: '/answer',
      name: 'answer',
      component: () => import('@/views/active/components/oneYears/answer.vue'),
      meta: {
        title: '智娃有奖问答',
        requireAuth: true
      }
    },
    {
      path: '/shoppingFestival',
      name: 'shoppingFestival',
      component: () => import('@/views/active/components/shoppingFestival/shoppingFestival.vue'),
      meta: {
        title: '奖品领取页',
        requireAuth: true
      }
    },
    {
      path: '/courseInfo/:type',
      name: 'courseInfo',
      component: () => import('@/views/active/components/shoppingFestival/courseInfo.vue'),
      meta: {
        title: '课程介绍',
        requireAuth: true
      }
    },
    {
      path: '/summerGiftbag',
      name: 'summerGiftbag',
      component: () => import('@/views/active/components/summer/index.vue'),
      meta: {
        title: '暑假活动',
        requireAuth: true
      }
    },
    {
      path: '/summerGiftbagDetail',
      name: 'summerGiftbagDetail',
      component: () => import('@/views/active/components/summer/detail.vue'),
      meta: {
        title: '详情',
        requireAuth: true
      }
    },
    {
      path: '/uploadMain',
      name: 'uploadMain',
      component: () => import('@/views/active/components/teacherUpload/teacherMain.vue'),
      meta: {
        title: '感恩教师节',
        requireAuth: true
      }
    },
    {
      path: '/chooseModal',
      name: 'chooseModal',
      component: () => import('@/views/active/components/teacherUpload/chooseModal.vue'),
      meta: {
        title: '选择模板',
        requireAuth: true
      }
    },
    {
      path: '/fillin',
      name: 'fillin',
      component: () => import('@/views/active/components/teacherUpload/fillin.vue'),
      meta: {
        title: '填写祝福语',
        requireAuth: true
      }
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/active/components/teacherUpload/upload.vue'),
      meta: {
        title: '上传图片',
        requireAuth: true
      }
    },
    {
      path: '/uploadResult',
      name: 'uploadResult',
      component: () => import('@/views/active/components/teacherUpload/uploadResult.vue'),
      meta: {
        title: '提示',
        requireAuth: true
      }
    },
    /**
     * 2020 双十一活动 start
     */
    {
      path: '/doubleEleven',
      name: 'doubleEleven',
      component: () => import('@/views/active/components/doubleEleven/index.vue'),
      meta: {
        title: '智娃双11狂欢开启',
        requireAuth: true
      }
    },
    // 智娃双11优惠购
    {
      path: '/preferential',
      name: 'preferential',
      component: () => import('@/views/active/components/doubleEleven/preferential.vue'),
      meta: {
        title: '智娃双11优惠购',
        requireAuth: true
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const _getOpenId = (code, name, params) => {
  getOpenid({
    code: code
  }).then(res => {
    if (res.data.code === 200) {
      sessionStorage.setItem('openid', res.data.data.openid.openid)
      if (name === 'summerActive' || name === 'summerActiveTwo' || name === 'teacherActivePromotion' || name === 'summerActiveThree') {
        router.replace({
          name: name,
          params: {
            ...params,
            openid: res.data.data.openid.openid
          }
        })
      } else if (name === 'shoppingVisitor' || name === 'skillDescriptionVisitor' || name === 'skillListsVisitor') {
        router.replace({
          name: name,
          params: params
        })
      } else {
        isLogin(res.data.data.openid.openid, name, params)
      }
    }
  })
}

router.beforeEach((to, from, next) => {
  // 对接小天才
  if (getSearchString('origin') === 'xiaotiancai') {
    store.commit('getXTC', 1)
    window.xtc.getOpenId({
      appId: '100008',
      complete: function (data, code) {
        console.log(data)
      },
      success: function (data) {
        // alert(JSON.stringify(data))
        store.commit('getXTCopenId', data.openId)

        store.dispatch('_kidLists').then(res => {
          store.commit('changeLoading', false)
          // alert('kidList:' + JSON.stringify(res))
          if (store.state.isXTC == 1 && res.length == 0) { // eslint-disable-line
            Dialog.alert({
              message: '暂无相关手表的绑定信息。\n请搜索微信公众号“智娃陪读机器人”扫码完成手表绑定',
              confirmButtonText: '知道了'
            })
          }
        })
      },
      fail: function (data, code) {
        Dialog.alert({
          message: '获取openId失败'
        })
      }
    })
  }
  // else {
  //   let ua = navigator.userAgent.toLowerCase()
  //   let isWeixin = ua.indexOf('micromessenger') !== -1
  //   if (!isWeixin) {
  //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=888'
  //   }
  // }
  // 如果进入的页面存在code参数，则进行是否登录校验
  // 如果进入的是首页，进行openid自动登录，这种情况是防止401 token 过期后跳转登录
  if (to.query.code) {
    _getOpenId(to.query.code, to.name, to.params)
  } else if (to.query.name === 'login') {
    let openid = sessionStorage.getItem('openid')
    let name = sessionStorage.getItem('currentName')
    isLogin(openid, name)
  } else {
    next()
  }
})

router.afterEach((route) => {
  // 解决进去不跳转问题，后续结局后删除
  console.log('isRefresh:' + sessionStorage.isRefresh)
  if (route.query.code) {
    window.scrollTo(0, 0)
    clearTimeout(Timer)
    document.title = route.meta.title || '智娃陪读机器人'
    if (route.name !== 'login') {
      sessionStorage.setItem('currentName', route.name)
    }
    weiXinShare(route.fullPath)
    return true
  } else {
    if (sessionStorage.isRefresh == 1) {
      window.scrollTo(0, 0)
      clearTimeout(Timer)
      document.title = route.meta.title || '智娃陪读机器人'
      if (route.name !== 'login') {
        sessionStorage.setItem('currentName', route.name)
      }
      weiXinShare(route.fullPath)
    } else {
      sessionStorage.isRefresh = 1
      location.reload()
    }
  }
  // window.scrollTo(0, 0)
  // clearTimeout(Timer)
  // document.title = route.meta.title || '智娃陪读机器人'
  // if (route.name !== 'login') {
  //   sessionStorage.setItem('currentName', route.name)
  // }
  // weiXinShare(route.fullPath)
})

export default router
